export function addListeners({ pressedCallback, releasedCallback }) {
  window.addEventListener("keydown", (event) => {
    if (event.metaKey) {
      releasedCallback();

      return;
    }

    if (event.key === "Shift") {
      pressedCallback(event.key);
    } else {
      releasedCallback();
    }
  });

  window.addEventListener("keyup", () => {
    releasedCallback();
  });
}
